import { render } from "./IndustriesServe.vue?vue&type=template&id=22017dcd"
import script from "./IndustriesServe.vue?vue&type=script&lang=js"
export * from "./IndustriesServe.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__